import { Events } from '@/services/Events';
import { EquirectangularReflectionMapping, type Texture } from 'three';
// @ts-expect-error three/addons has no bundled types for this loader
import { RGBELoader } from 'three/addons/loaders/RGBELoader';

// Cached HDR equirectangular loader — one entry per path. Cleared
// on engine dispose.
class EnvironmentMapLoader {
    private static _cache = new Map<string, Promise<Texture>>();

    private static _loader = new RGBELoader();

    static loadEquirectangular(path: string): Promise<Texture> {
        const cached = EnvironmentMapLoader._cache.get(path);
        if (cached) {
            return cached;
        }
        const name = _getName(path);
        const promise = new Promise<Texture>((resolve, reject) => {
            Events.emit('loading-start', name);
            EnvironmentMapLoader._loader.load(
                path,
                (texture: Texture) => {
                    texture.mapping = EquirectangularReflectionMapping;
                    resolve(texture);
                },
                undefined,
                (error: unknown) => reject(new Error(String(error))),
            );
        });
        promise.then(() => Events.emit('loading-end', name)).catch(() => {});
        EnvironmentMapLoader._cache.set(path, promise);
        return promise;
    }

    static clear(): void {
        EnvironmentMapLoader._cache.clear();
    }
}

function _getName(path: string): string {
    const file = path.split('/').pop() ?? '';
    return file.split('.')[0];
}

export { EnvironmentMapLoader };
